import { Flag } from "@mui/icons-material";
import { Button } from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/query";
import { useTranslation } from "react-i18next";

import { useAppSelector } from "~/app/store";
import { useFcNavigate } from "~/hooks/useFcNavigate";

import { mixpanelTrack, useMixpanelPageName } from "~/lib/mixpanel-tracking";
import { selectWorkstationAutostoreGridId } from "~/redux/selectors/workstationsSelectors";
import { useGetNumberOfFlaggedBinsQuery } from "~/redux/warehouse/autostoreGrid.hooks";

const ManageFlaggedInventoryButton = () => {
  const { t } = useTranslation();
  const navigate = useFcNavigate();
  const trackedPageName = useMixpanelPageName();
  const autostoreGridId = useAppSelector(selectWorkstationAutostoreGridId);
  const isGetBinsLoading = useAppSelector(
    (state) => state.inventoryNew.isGetBinsLoading
  );
  const isAutostorePutawayDialogOpen = useAppSelector(
    (state) => state.inventoryNew.isAutostorePutawayDialogOpen
  );
  const {
    data: numberOfFlaggedBins,
    isSuccess: isGetNumberOfFlaggedBinsSuccess
  } = useGetNumberOfFlaggedBinsQuery(
    autostoreGridId ? { autostoreGridId } : skipToken,
    { refetchOnMountOrArgChange: true }
  );

  const handleClick = () => {
    navigate("/autostore-inventory/manage-flagged?autostore=true");
    mixpanelTrack({
      trackedPageName,
      type: "Button Click",
      label: "Manage Flagged Inventory"
    });
  };

  return (
    <Button
      onClick={handleClick}
      startIcon={<Flag />}
      variant="contained"
      color="secondary"
      sx={{ mb: 1, fontWeight: "normal" }}
      disabled={
        (isGetNumberOfFlaggedBinsSuccess && !numberOfFlaggedBins) ||
        isGetBinsLoading ||
        isAutostorePutawayDialogOpen
      }
    >
      {t("manage flagged bins")}
      {isGetNumberOfFlaggedBinsSuccess && numberOfFlaggedBins
        ? ` (${numberOfFlaggedBins})`
        : null}
    </Button>
  );
};

export default ManageFlaggedInventoryButton;
